module.exports = __webpack_public_path__ + "img/option_delete.d025cffc.svg";